import React from 'react';

import type { ForwardRefComponent } from '@coursera/cds-common';

import type { CommonActionsProps } from '@core/dialogs/common/types';

import { useDialogContext } from './DialogContextProvider';
import { getActionsCss, getStickyActionsCss } from './styles';

type ActionsType = ForwardRefComponent<HTMLDivElement, Props>;

export type Props = CommonActionsProps;

const styles = getActionsCss();
const stickyStyles = getStickyActionsCss();

const Actions: ActionsType = React.forwardRef(function Actions(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { sticky } = useDialogContext();
  const { children, ...rest } = props;

  return (
    <div
      ref={ref}
      css={[styles, sticky === 'actions' && stickyStyles]}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Actions;
